import { lodash } from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Table, TablePaginationProps, TableSetRowHref } from 'libs/ui';

import { DirectoryRecordItemType } from '../../types';

import { renderMore, renderValue } from './renders';

export interface DirectoryRecordsTableProps extends TablePaginationProps {
  columns: { field: string; title: string }[];
  values: DirectoryRecordItemType[];
  loading?: boolean;
  noRowsLabel?: string;
  setRowHref?: TableSetRowHref<any>;
  onRecordArchive?: (item: DirectoryRecordItemType) => void;
  onRecordDearchive?: (item: DirectoryRecordItemType) => void;
}

export const DirectoryRecordsTable = ({
  columns,
  values,
  noRowsLabel,
  setRowHref,
  onRecordArchive,
  onRecordDearchive,
  ...tableProps
}: DirectoryRecordsTableProps) => {
  const { t } = useTranslation();

  const isShowMore = Boolean(onRecordArchive || onRecordDearchive);

  return (
    <Table<any>
      columns={lodash.compact([
        ...columns.map((column) => ({
          field: column.field,
          title: column.title,
          flex: 1,
          minWidth: 150,
          renderCell: renderValue,
        })),
        isShowMore && {
          field: 'more',
          title: '',
          width: 56,
          align: 'center',
          renderCell: (item) =>
            renderMore(t, item, {
              onClickArchive: onRecordArchive,
              onClickDearchive: onRecordDearchive,
            }),
        },
      ])}
      noRowsLabel={noRowsLabel}
      rows={values}
      setRowHref={setRowHref}
      {...tableProps}
    />
  );
};
